/* eslint-disable camelcase */
export enum ServicesSubscriptionTypes {
  GET_SERVICE_SUBSCRIPTION_STATUS_REQUEST = '@service_subscription/GET_SERVICE_SUBSCRIPTION_STATUS_REQUEST',
  GET_SERVICE_SUBSCRIPTION_STATUS_SUCCESS = '@service_subscription/GET_SERVICE_SUBSCRIPTION_STATUS_SUCCESS',
  GET_SERVICE_SUBSCRIPTION_STATUS_FAILURE = '@service_subscription/GET_SERVICE_SUBSCRIPTION_STATUS_FAILURE',
}

export interface ServiceSubscriptionTypes {
  current_signature: boolean | null;
  has_any_signature: boolean | null;
  in_trial_period: number | null;
  status_message: string | null;
  show_accept: boolean;
  service_paralyzed: boolean;
}

export interface ServicesSubscriptionData {
  [key: string]: ServiceSubscriptionTypes;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface ServicesSubscriptionState {
  readonly servicesSubscriptions: ServicesSubscriptionData;
  readonly request: RequestState;
}
